// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 278;
export const MINI_DRAWER_WIDTH = 68;

const config = {
  fontFamily: `'Outfit', sans-serif`
};

export default config;
